export const styles = {
  dialog: {
    "& .MuiDialog-paper": {
      minWidth: "800px",
      maxWidth: "800px",
    },
  },
  dialogContainer: {
    width: "800px",
    overflow: "auto",
  },
  titleContainer: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: 2,
  },
  titleText: {
    fontWeight: 600,
  },
  closeButton: {
    padding: 0,
  },
  content: {
    padding: 2,
    height: "100%",
    overflow: "hidden",
  },
  actions: {
    padding: 2,
  },
  iframe: {
    width: "100%",
    border: "none",
    overflow: "hidden",
    height: "600px",
  },
  headerSection: {
    padding: 2,
    backgroundColor: "#f5f8fa",
    borderRadius: 1,
    marginBottom: 2,
  },
  headerSectionItem: { display: "flex", marginBottom: 1 },
  headerSectionItemLabel: { width: 150, fontWeight: "bold" },
};
